/* eslint-disable react-hooks/exhaustive-deps */

import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {useMutation, useQuery} from "@apollo/react-hooks";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import {Select} from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import BackupOutlinedIcon from "@material-ui/icons/BackupOutlined";
import ClearIcon from "@material-ui/icons/Clear";
import {notify} from "../../utils/notify";
import {CREATE_CONTACT_LIST, GET_CONTACT_LIST, UPDATE_CONTACT_LIST} from "../../database/queries/contactListQueries";
import FormHelperText from "@material-ui/core/FormHelperText";
import usePersistentStore from "../../persistentStore";
import {useHistory, useParams} from "react-router-dom";

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        '& p': {
            color: 'red',
        }
    },
    grow: {
        flexGrow: 1,
    },
    formControl: {
        'input': {
            '&::placeholder': {
                color: 'blue'
            }
        },
        '& .MuiFormLabel-root': {
            color: '#a0aec0'
        },
    },
    formControlError: {
        'input': {
            '&::placeholder': {
                color: 'red'
            }
        },
        '& .MuiFormLabel-root': {
            color: 'red'
        },
        '& .MuiInput-underline:before': {
            borderColor: 'red'
        },
    },
    gridContainer: {
        // // marginTop: 2,
        // flexGrow: 1,
        overflow: 'auto',
        overflowY: 'scroll',
        padding: 10,
        border: '1px solid #d3d4d5'
    },
    typeField: {
        paddingRight: 10
    },
    priorityField: {
        paddingLeft: 30,
        paddingRight: 30
    },
    leftField: {
        paddingRight: 10
    },
    middleField: {
        paddingLeft: 10,
        paddingRight: 10
    },
    rightField: {
        paddingLeft: 10,
    },
    hidden: {
        display: 'none',
    },
    noMargin: {
        marginBottom: 0,
        minHeight: 0
    },
    shrink: {
        transform: 'translate(0, 1.5px) scale(0.75)',
        transformOrigin: 'top left',
    }
}));

const INITIAL_CONTACT_LIST = {
    contactListId: null,
    shareCategoryType: '',
    shareCategoryId: null,
    contactListName: '',
    contactListDescription: '',
    contactListType: 'default',
};

const ContactListEdit = props => {
    const classes = useStyles();
    const [globalPersistentState, globalPersistentActions] = usePersistentStore();
    const [contactList, setContactList] = useState({
        ...INITIAL_CONTACT_LIST,
        shareCategoryType: props.shareCategoryType ? props.shareCategoryType : 'personal',
        shareCategoryId: props.shareCategoryId ? props.shareCategoryId : 'personal',
    });
    const [errors, setErrors] = useState({});
    const history = useHistory();
    let {editId} = useParams();

    const {loading: getContactListLoading, error: getContactListError, data: getContactListData} = useQuery(GET_CONTACT_LIST, {
        skip: !props.editId || props.editId === 'new',
        variables: {contactListId: props.editId},
    });

    const [updateContactList, {error: updateContactListError}] = useMutation(UPDATE_CONTACT_LIST, {
        variables: {
            changedContactList: {
                contactListId: contactList.contactListId,
                shareCategoryType: contactList.shareCategoryType,
                shareCategoryId: contactList.shareCategoryId,
                contactListName: contactList.contactListName,
                contactListDescription: contactList.contactListDescription,
                contactListType: contactList.contactListType,
            }
        }
    });

    const [createContactList, {error: createContactListError}] = useMutation(CREATE_CONTACT_LIST, {
        variables: {
            newContactList: {
                shareCategoryType: contactList.shareCategoryType,
                shareCategoryId: contactList.shareCategoryId,
                contactListName: contactList.contactListName,
                contactListDescription: contactList.contactListDescription,
                contactListType: contactList.contactListType,
            }
        }
    });

    useEffect(() => {
        if (createContactListError) notify('createContactListError', 'error', createContactListError.message);
        if (getContactListError) notify('getContactListError', 'error', getContactListError.message);
        if (getContactListError) notify('getContactListError', 'error', getContactListError.message);
        if (updateContactListError) notify('updateContactListError', 'error', updateContactListError.message);
    }, [createContactListError, getContactListError, updateContactListError]);

    useEffect(() => {
        if (getContactListData && getContactListData.contactList) {
            let fetchedContactList = {
                contactListId: getContactListData.contactList.contactListId,
                shareCategoryType: getContactListData.contactList.shareCategoryType,
                shareCategoryId: getContactListData.contactList.shareCategoryType,
                contactListName: getContactListData.contactList.contactListName,
                contactListDescription: getContactListData.contactList.contactListDescription,
                contactListType: getContactListData.contactList.contactListType,
            };

            setContactList(fetchedContactList);
            if (globalPersistentState.dirty) globalPersistentActions.setDirty(false);
        }
    }, [getContactListData]);

    useEffect(() => {
    }, [contactList]);

    useEffect(() => {
        if (globalPersistentState.dirty) globalPersistentActions.setDirty(false);
    }, []);

    const handleChange = (e) => {
        const updatedContactList = {
            ...contactList,
            [e.target.name]: e.target.value
        };

        setContactList(updatedContactList);
        if (!globalPersistentState.dirty) globalPersistentActions.setDirty(true);
    };

    const validateForm = () => {
        setErrors({});
        let newError = {};
        if (!contactList.contactListName || contactList.contactListName.length < 3) newError.contactListName = 'ContactList name must be at least 3 characters long';
        if (!contactList.contactListType) newError.contactListType = 'Please select a List Type';

        if (Object.keys(newError).length > 0) {
            setErrors(newError);
            return false;
        } else {
            return true;
        }
    };

    if (getContactListLoading) return <p>Loading ...</p>;

    return (
        <form className={classes.root}>
            <AppBar color={props.color ? props.color : 'default'} position="static" className={classes.noMargin}>
                <Toolbar className={classes.noMargin}>
                    <Typography
                        variant="h6"
                        color="inherit"
                        className={classes.title}
                    >
                        {props.shareCategoryName ? props.shareCategoryName + ' ' : ''} {contactList.contactListName ? contactList.contactListName : "New List"} Details
                    </Typography>
                    <div className={classes.grow}/>
                    <IconButton
                        aria-label="save contactList"
                        id={"save-contact-list"}
                        color="inherit"
                        size="small"
                        disabled={!globalPersistentState.dirty}
                        onClick={() => {
                            if (validateForm()) {
                                if (contactList.contactListId && contactList.contactListId !== 'new') {
                                    updateContactList().then(function (updateResult) {
                                        notify('updateContactList', 'info', 'List updated');
                                        if (globalPersistentState.dirty) globalPersistentActions.setDirty(false);
                                        history.goBack();
                                        props.parentRefresh();
                                    })
                                } else {
                                    createContactList().then(function (createResult) {
                                        notify('createContactList', 'info', 'List created');
                                        if (globalPersistentState.dirty) globalPersistentActions.setDirty(false);
                                        history.goBack();
                                        props.parentRefresh();
                                    })
                                }
                            }
                        }}>
                        <BackupOutlinedIcon/>
                    </IconButton>
                    <IconButton
                        aria-label="cancel edit contactList"
                        id={"cancel-save-contact-list"}
                        color="inherit"
                        size="small"
                        onClick={() => {
                            history.goBack();
                            props.parentRefresh();
                        }}
                    >
                        <ClearIcon/>
                    </IconButton>
                </Toolbar>
            </AppBar>

            {contactList && (<Grid container className={classes.gridContainer}>
                <Grid item xs={4} className={classes.leftField}>
                    <FormControl
                        className={errors.contactListName ? classes.formControlError : classes.formControl}
                        margin="dense"
                        size="small"
                        fullWidth
                    >
                        <TextField
                            required
                            id="contactListName"
                            name="contactListName"
                            label="List name"
                            fullWidth
                            size="small"
                            onChange={handleChange}
                            value={contactList.contactListName}
                        />
                        <FormHelperText>
                            {errors.contactListName}
                        </FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <FormControl
                        className={classes.formControl}
                        margin="dense"
                        size="small"
                        fullWidth
                    >
                        <TextField
                            id="contactListDescription"
                            name="contactListDescription"
                            label="List description"
                            fullWidth
                            size="small"
                            multiline
                            value={contactList.contactListDescription}
                            onChange={handleChange}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={6} className={classes.typeField}>
                    <FormControl
                        className={errors.contactListType ? classes.formControlError : classes.formControl}
                        margin="dense"
                        size="small"
                        fullWidth
                        required
                    >
                        <InputLabel id="label-contact-list-type">List Type</InputLabel>
                        <Select
                            required
                            id="contactListType"
                            name="contactListType"
                            labelid="label-contact-list-type"
                            fullWidth
                            size="small"
                            value={contactList.contactListType}
                            onChange={handleChange}
                        >
                            <MenuItem value="default" id="contact-list-type-not-started">Default</MenuItem>
                            <MenuItem value="suppression" id="contact-list-type-in-progress">Suppression</MenuItem>
                            <MenuItem value="test" id="contact-list-type-on-hold">Test</MenuItem>
                        </Select>
                        <FormHelperText>
                            {errors.contactListType}
                        </FormHelperText>
                    </FormControl>
                </Grid>
            </Grid>)}
        </form>
    )
};

export default ContactListEdit
